import {
  AfterContentChecked,
  AfterViewChecked,
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Injectable,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  NgZone,
} from "@angular/core";
import { Router } from "@angular/router";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { ServiceStock } from "../service-stock.service";

import {
  zip,
  toRem,
  toVh,
  toVhR,
  toVhU,
  toVw,
  toVwR,
  toVwU,
  $fontWeightBold,
  $fontWeightExtraBold,
  $fontWeightLight,
  $fontWeightMedium,
  $fontWeightRegular,
  $fontWeightSemiBold,
} from "../utils/ux";

import appStartLinks from "../_files/app-start-links.json";
import appStartProducts from "../_files/app-start-products.json";
import appStartTween0 from "../_files/app-start-tween-0.json";
import appStartTween1 from "../_files/app-start-tween-1.json";
import appStartTween2 from "../_files/app-start-tween-2.json";
import appStartTween3 from "../_files/app-start-tween-3.json";
import appStartTween4 from "../_files/app-start-tween-4.json";
import appStartTween5 from "../_files/app-start-tween-5.json";
import appStartTween6 from "../_files/app-start-tween-6.json";
import appStartTween7 from "../_files/app-start-tween-7.json";
import { CommonService } from "../common.service";
import { PopupComponent } from "../common/components/popup/popup.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { IPopupScreenData } from "../common/models/popup-screen-data.model";
import { NativeStorageService } from "../services/mobile/native-storage.service";
import { PreLoginService } from "../pre-login/pre-login.service";
import { ILoginauthPayLoad } from "../pre-login/Pre-login.model";
import { ResponsiveService } from "../responsive.service";
import { Data } from "../DataService";
import { DeviceDetectorService } from "ngx-device-detector";
import { MobileService } from "src/app/mobile.services";
import { Device } from "@ionic-native/device/ngx";

declare let Swiper: any;

declare var $: any;

gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);
gsap.config({
  force3D: true,
});

const CARD_BG_SVGS = [
  appStartTween0,
  appStartTween1,
  appStartTween2,
  appStartTween3,
  appStartTween4,
  appStartTween5,
  appStartTween6,
  appStartTween7,
];

const CARD_BG_TRANSLATE_TWEENS = [
  {
    x: toVw(-60.05),
    y: toVh(176.99),
    rotation: 0,
    width: toVw(2187.39),
    height: toVh(375.96),
  },
  {
    x: toVw(-521.51),
    y: toVh(120.64),
    rotation: -7,
    width: toVw(2008.86),
    height: toVh(439.32),
  },
  {
    x: toVw(-488.49),
    y: toVh(161.21),
    rotation: -7,
    width: toVw(1886),
    height: toVh(647.7),
  },
  {
    x: toVw(-488.49),
    y: toVh(161.21),
    rotation: 0,
    width: toVw(1886),
    height: toVh(447.7),
  },
  {
    x: toVw(-700.85),
    y: toVh(123.61),
    rotation: -14,
    width: toVw(2025.2),
    height: toVh(497.35),
  },
  {
    x: toVw(-1612.04),
    y: toVh(145.09),
    rotation: 0,
    width: toVw(2640.37),
    height: toVh(453.82),
  },
  {
    x: toVw(-1463.0),
    y: toVh(240.22),
    rotation: 0,
    width: toVw(2046.41),
    height: toVh(351.73),
  },
  {
    x: toVw(-1640.0),
    y: toVh(240.22),
    rotation: 0,
    width: toVw(2046.41),
    height: toVh(351.73),
  },
];

@Component({
  selector: "page-app-start",
  templateUrl: "./page.component.html",
  styleUrls: ["./page.component.scss"],
})
export class PageAppStartComponent
  implements
  OnInit,
  AfterViewInit,
  OnDestroy,
  AfterViewChecked,
  AfterContentChecked,
  DoCheck
  {
  @ViewChild("cardSelector") cardSelector: ElementRef;
  @ViewChild("cardBgSelector") cardBgSelector: ElementRef;

  @Output("carouselSwipeCompleted")
  carouselSwipeCompleted: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output("carouselSwipeReversed")
  carouselSwipeReversed: EventEmitter<boolean> = new EventEmitter<boolean>();

  private VIEWPORT_HEIGHT = 0;
  private VIEWPORT_WIDTH = 0;
  private CARD_MARGIN = 0;
  private CARD_WIDTH = 0;
  private CARD_WIDTH_ACTIVE = 0;
  private CARD_WIDTH_VW: string = "0vw";
  private CARD_WIDTH_ACTIVE_VW: string = "0vw";
  private CARD_HEIGHT_VH: string = "0vh";
  private CARD_HEIGHT_ACTIVE_VH: string = "0vh";
  private CARD_BG_WIDTH = 0;
  private CARD_MOVEMENT_WIDTH = 0;
  private CARD_PROGRESS_MOVEMENT_WIDTH = 0;
  private STACK_CARD_MOVEMENT_WIDTH = 0;
  private CARD_SELECTION_ANIMATION_DURATION = 0;
  private STACK_CARD_SELECTION_ANIMATION_DURATION = 0;

  cards = [];

  selectedCardIndex = -1;

  activeCardIndex = 0;
  initialCardMobile = 2;
  initialCardDesktop = 2;

  private swipedCardIndex = -1;

  private panCardIndex = -1;

  private touchCardIndex = -1;

  private playInProgress = false;

  private oldCardIndex = 0;

  resetScroll = false;

  stopScroll = false;
  isMobile: boolean = false;

  private TOTAL_CARD_SELECTOR_WIDTH = 0;

  private scrollunlistener: () => void;
  private touchunlistener: () => void;
  private scrollertouchunlistener: () => void;
  private cardselectortouchunlistener: () => void;

  constructor(
    private renderer2: Renderer2,
    private changeDetectorRef: ChangeDetectorRef,
    private applicationRef: ApplicationRef,
    private router: Router,
    public services: ServiceStock,
    protected _appCommon: CommonService,
    private _dialog: MatDialog,
    private _nativeStorage: NativeStorageService,
    private _preLoginService: PreLoginService,
    private _router: Router,
    public dataStore: Data,
    private _responsive: ResponsiveService,
    private deviceService: DeviceDetectorService,
    public mobileService: MobileService,
    private ngZone: NgZone,
    public device: Device
  ) {
    this.isMobile = this.deviceService.isMobile();
  }

  calculateDimensions() {
    console.log(
      "calculateDimensions",
      screen.width,
      screen.height,
      window.innerWidth,
      window.innerHeight
    );
    this.CARD_MARGIN = toVw(20);
    this.CARD_WIDTH = toVw(120);
    this.CARD_WIDTH_ACTIVE = toVw(144);
    this.CARD_WIDTH_VW = toVwU(120);
    this.CARD_WIDTH_ACTIVE_VW = toVwU(144);
    this.CARD_HEIGHT_VH = toVwU(140);
    this.CARD_HEIGHT_ACTIVE_VH = toVwU(168);
    this.CARD_BG_WIDTH = toVw(375);
    this.CARD_MOVEMENT_WIDTH = Math.floor(this.CARD_MARGIN + this.CARD_WIDTH);
    this.CARD_PROGRESS_MOVEMENT_WIDTH = Math.floor(
      this.CARD_MARGIN * 2 + this.CARD_WIDTH
    );
    this.STACK_CARD_MOVEMENT_WIDTH = toVw(280);
    this.CARD_SELECTION_ANIMATION_DURATION = 1000 / 1000.0; //this.CARD_MOVEMENT_WIDTH / 1000.0;
    this.STACK_CARD_SELECTION_ANIMATION_DURATION = 200 / 1000.0; //this.STACK_CARD_MOVEMENT_WIDTH / 1000.0;
    this.VIEWPORT_HEIGHT = screen.height;
    this.VIEWPORT_WIDTH = screen.width;

    console.log(
      "calculateDimensions",
      this.VIEWPORT_HEIGHT,
      this.VIEWPORT_WIDTH,
      screen.width,
      screen.height,
      window.innerWidth,
      window.innerHeight
    );
  }

  private cardSelectorCarouselNextAsCurrentAIs = [];
  private cardSelectorCarouselPreviousAsCurrentAIs = [];

  private nextAsCurrentCardTimeline;
  private nextNextAsCurrentCardTimeline;
  private previousAsCurrentCardTimeline;

  teardownCarouselCardChangeAnimation() {
    this.calculateDimensions();

    if (this.nextAsCurrentCardTimeline) {
      this.nextAsCurrentCardTimeline.kill();
      this.nextAsCurrentCardTimeline = null;
    }
    if (this.previousAsCurrentCardTimeline) {
      this.previousAsCurrentCardTimeline.kill();
      this.previousAsCurrentCardTimeline = null;
    }
  }

  setupCarouselCardChangeAnimation() {
    console.log(
      "setupCarouselCardChangeAnimation",
      this.CARD_SELECTION_ANIMATION_DURATION,
      this.VIEWPORT_HEIGHT,
      this.VIEWPORT_WIDTH
    );
    this.nextAsCurrentCardTimeline = gsap.timeline({
      paused: true,
      duration: this.CARD_SELECTION_ANIMATION_DURATION,
      ease: "none",
      autoRemoveChildren: false,
      smoothChildTiming: true,
    });
    this.nextAsCurrentCardTimeline.eventCallback("onComplete", () => {
      console.log("activeToFromInactiveTimeline", "onComplete");
    });

    this.nextAsCurrentCardTimeline.eventCallback("onReverseComplete", () => {
      console.log("onReverseComplete ", "activeToFromInactiveTimeline");
      this.nextAsCurrentCardTimeline.reversed(false).pause().seek(0);
    });

    this.nextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card",
      {
        css: {
          width: toVwU(144),
          height: toVwU(168),
        },
      },
      {
        css: {
          width: toVwU(120),
          height: toVwU(140),
        },
      },
      0
    );

    this.nextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card >div",
      {
        css: {
          scaleX: 1.2,
          scaleY: 1.2,
        },
      },
      {
        css: {
          scaleX: 1,
          scaleY: 1,
        },
      },
      0
    );
    /*
    this.nextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card >div img",
      {
        css: {
          scale: 1.2,
        },
      },
      {
        css: {
          scale: 1,
        },
      },
      0
    );
    */
    this.nextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card p.title",
      {
        css: {
          y: 0,
          scale: 1,
          lineHeight: toRem(20),
        },
      },
      {
        css: {
          y: toVwU(-18),
          scale: 0.75,
          lineHeight: toRem(11),
        },
      },
      0
    );

    if (this.activeCardIndex < this.cards.length - 1) {
      this.nextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .after-active-card",
        {
          css: {
            width: toVwU(120),
            height: toVwU(140),
          },
        },
        {
          css: {
            width: toVwU(144),
            height: toVwU(168),
          },
        },
        0
      );

      this.nextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .after-active-card >div",
        {
          css: {
            scaleX: 1,
            scaleY: 1,
          },
        },
        {
          css: {
            scaleX: 1.2,
            scaleY: 1.2,
          },
        },
        0
      );
      /*
      this.nextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .after-active-card >div img",
        {
          css: {
            scale: 1,
          },
        },
        {
          css: {
            scale: 1.2,
          },
        },
        0
      );
      */
      this.nextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .after-active-card p.title",
        {
          css: {
            y: toVwU(-18),
            scale: 0.75,
            lineHeight: toRem(11),
          },
        },
        {
          css: {
            y: 0,
            scale: 1,
            lineHeight: toRem(20),
          },
        },
        0
      );
    }

    this.nextNextAsCurrentCardTimeline = gsap.timeline({
      paused: true,
      duration: this.CARD_SELECTION_ANIMATION_DURATION,
      ease: "none",
      autoRemoveChildren: false,
      smoothChildTiming: true,
    });
    this.nextNextAsCurrentCardTimeline.eventCallback("onComplete", () => {
      console.log("activeToFromInactiveTimeline", "onComplete");
    });

    this.nextNextAsCurrentCardTimeline.eventCallback(
      "onReverseComplete",
      () => {
        console.log("onReverseComplete ", "activeToFromInactiveTimeline");
        this.nextNextAsCurrentCardTimeline.reversed(false).pause().seek(0);
      }
    );

    this.nextNextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card",
      {
        css: {
          width: toVwU(144),
          height: toVwU(168),
        },
      },
      {
        css: {
          width: toVwU(120),
          height: toVwU(140),
        },
      },
      0
    );

    this.nextNextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card >div",
      {
        css: {
          scaleX: 1.2,
          scaleY: 1.2,
        },
      },
      {
        css: {
          scaleX: 1,
          scaleY: 1,
        },
      },
      0
    );
    /*
    this.nextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card >div img",
      {
        css: {
          scale: 1.2,
        },
      },
      {
        css: {
          scale: 1,
        },
      },
      0
    );
    */
    this.nextNextAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card p.title",
      {
        css: {
          y: 0,
          scale: 1,
          lineHeight: toRem(20),
        },
      },
      {
        css: {
          y: toVwU(-18),
          scale: 0.75,
          lineHeight: toRem(11),
        },
      },
      0
    );

    if (this.activeCardIndex < this.cards.length - 2) {
      this.nextNextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card:nth-child(" + (this.activeCardIndex + 3) + ") .card",
        {
          css: {
            width: toVwU(120),
            height: toVwU(140),
          },
        },
        {
          css: {
            width: toVwU(144),
            height: toVwU(168),
          },
        },
        0
      );

      this.nextNextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card:nth-child(" +
        (this.activeCardIndex + 3) +
        ") .card >div",
        {
          css: {
            scaleX: 1,
            scaleY: 1,
          },
        },
        {
          css: {
            scaleX: 1.2,
            scaleY: 1.2,
          },
        },
        0
      );
      /*
      this.nextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .after-active-card >div img",
        {
          css: {
            scale: 1,
          },
        },
        {
          css: {
            scale: 1.2,
          },
        },
        0
      );
      */
      this.nextNextAsCurrentCardTimeline.fromTo(
        "ux-app-start-card:nth-child(" +
        (this.activeCardIndex + 3) +
        ") .card p.title",
        {
          css: {
            y: toVwU(-18),
            scale: 0.75,
            lineHeight: toRem(11),
          },
        },
        {
          css: {
            y: 0,
            scale: 1,
            lineHeight: toRem(20),
          },
        },
        0
      );
    }

    this.previousAsCurrentCardTimeline = gsap.timeline({
      paused: true,
      duration: this.CARD_SELECTION_ANIMATION_DURATION,
      ease: "none",
      autoRemoveChildren: false,
      smoothChildTiming: true,
    });
    this.previousAsCurrentCardTimeline.eventCallback("onComplete", () => {
      console.log("activeToFromInactiveTimeline", "onComplete");
    });

    this.previousAsCurrentCardTimeline.eventCallback(
      "onReverseComplete",
      () => {
        console.log("onReverseComplete ", "activeToFromInactiveTimeline");
        this.previousAsCurrentCardTimeline.reversed(false).pause().seek(0);
      }
    );

    this.previousAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card",
      {
        css: {
          width: toVwU(144),
          height: toVwU(168),
        },
      },
      {
        css: {
          width: toVwU(120),
          height: toVwU(140),
        },
      },
      0
    );

    this.previousAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card >div",
      {
        css: {
          scaleX: 1.2,
          scaleY: 1.2,
        },
      },
      {
        css: {
          scaleX: 1,
          scaleY: 1,
        },
      },
      0
    );
    /*
    this.previousAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card >div img",
      {
        css: {
          scaleX: 1.2,
          scaleY: 1.2,
        },
      },
      {
        css: {
          scaleX: 1,
          scaleY: 1,
        },
      },
      0
    );
    */
    this.previousAsCurrentCardTimeline.fromTo(
      "ux-app-start-card .active-card p.title",
      {
        css: {
          y: 0,
          scale: 1,
          lineHeight: toRem(20),
        },
      },
      {
        css: {
          y: toVwU(-18),
          scale: 0.75,
          lineHeight: toRem(11),
        },
      },
      0
    );

    if (this.activeCardIndex > 0) {
      this.previousAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .before-active-card",
        {
          css: {
            width: toVwU(120),
            height: toVwU(140),
          },
        },
        {
          css: {
            width: toVwU(144),
            height: toVwU(168),
          },
        },
        0
      );

      this.previousAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .before-active-card >div",
        {
          css: {
            scaleX: 1,
            scaleY: 1,
          },
        },
        {
          css: {
            scaleX: 1.2,
            scaleY: 1.2,
          },
        },
        0
      );
      /*
      this.previousAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .before-active-card >div img",
        {
          css: {
            scaleX: 1,
            scaleY: 1,
          },
        },
        {
          css: {
            scaleX: 1.2,
            scaleY: 1.2,
          },
        },
        0
      );
      */
      this.previousAsCurrentCardTimeline.fromTo(
        "ux-app-start-card .before-active-card p.title",
        {
          css: {
            y: toVhU(-18),
            scale: 0.75,
            lineHeight: toRem(11),
          },
        },
        {
          css: {
            y: 0,
            scale: 1,
            lineHeight: toRem(20),
          },
        },
        0
      );
    }
  }

  private cardSelectorCarouselFirstCardAI;
  private cardSelectorCarouselLastCardAI;

  setupCarouselAnimation() {
    this.cardSelectorCarouselNextAsCurrentAIs = new Array();
    this.cardSelectorCarouselPreviousAsCurrentAIs = new Array();

    let nextAsCurrentPosition = 0;
    let previousAsCurrentPosition = 0;
    for (let cardIndex = 0; cardIndex < this.cards.length; ++cardIndex) {
      let translatePositionNextAsCurrent;
      let translatePositionPreviousAsCurrent;

      if (cardIndex == 0) {
        translatePositionNextAsCurrent = [
          nextAsCurrentPosition,
          nextAsCurrentPosition,
        ];
        this.cardSelectorCarouselFirstCardAI = gsap.timeline({
          paused: true,
          duration: this.CARD_SELECTION_ANIMATION_DURATION / 10,
          ease: "power1.inOut",
          smoothChildTiming: true,
        });
        this.cardSelectorCarouselFirstCardAI.eventCallback("onComplete", () => {
          console.log("onComplete cardSelectorCarouselFirstCardAI", cardIndex);
          this.cardSelectorCarouselFirstCardAI.reverse();
        });
        this.cardSelectorCarouselFirstCardAI.eventCallback(
          "onReverseComplete",
          () => {
            console.log(
              "onReverseComplete cardSelectorCarouselFirstCardAI",
              cardIndex
            );
            this.doResetScroll();
          }
        );
        this.cardSelectorCarouselFirstCardAI.fromTo(
          ".card-selector",
          { css: { x: nextAsCurrentPosition } },
          { css: { x: nextAsCurrentPosition + 30 } },
          0
        );
        this.cardSelectorCarouselFirstCardAI.fromTo(
          ".card-selector ux-app-start-card:first-child >div",
          { css: { boxShadow: "0px 8px " + toVwU(29) + " 1px #00000029" } },
          { css: { boxShadow: "-10px 8px " + toVwU(29) + " 1px #00000050" } },
          0
        );
        this.cardSelectorCarouselFirstCardAI.fromTo(
          ".card-bg-selector .card-bg-selector-holder",
          { css: { x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"] } },
          { css: { x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"] + 30 } },
          0
        );
      } else {
        translatePositionNextAsCurrent = [
          nextAsCurrentPosition,
          nextAsCurrentPosition - this.CARD_MOVEMENT_WIDTH,
        ];
        nextAsCurrentPosition -= this.CARD_MOVEMENT_WIDTH;
      }

      if (cardIndex == this.cards.length - 1) {
        translatePositionPreviousAsCurrent = [
          previousAsCurrentPosition,
          previousAsCurrentPosition,
        ];
        this.cardSelectorCarouselLastCardAI = gsap.timeline({
          paused: true,
          duration: this.CARD_SELECTION_ANIMATION_DURATION / 10,
          ease: "power1.inOut",
          smoothChildTiming: true,
        });
        this.cardSelectorCarouselLastCardAI.fromTo(
          ".card-selector",
          { css: { x: previousAsCurrentPosition } },
          { css: { x: previousAsCurrentPosition - 30 } },
          0
        );
        this.cardSelectorCarouselLastCardAI.fromTo(
          ".card-selector ux-app-start-card:last-child >div",
          { css: { boxShadow: "0px 8px " + toVwU(29) + " 1px #00000029" } },
          { css: { boxShadow: "10px 8px " + toVwU(29) + " 1px #00000080" } },
          0
        );
        this.cardSelectorCarouselLastCardAI.fromTo(
          ".card-bg-selector .card-bg-selector-holder",
          { css: { x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"] } },
          { css: { x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"] - 30 } },
          0
        );
        this.cardSelectorCarouselLastCardAI.eventCallback("onComplete", () => {
          console.log("onComplete cardSelectorCarouselLastCardAI", cardIndex);
          this.cardSelectorCarouselLastCardAI.reverse();
        });
        this.cardSelectorCarouselLastCardAI.eventCallback(
          "onReverseComplete",
          () => {
            console.log(
              "onReverseComplete cardSelectorCarouselLastCardAI",
              cardIndex
            );
            this.doResetScroll();
          }
        );
      } else {
        translatePositionPreviousAsCurrent = [
          previousAsCurrentPosition - this.CARD_MOVEMENT_WIDTH,
          previousAsCurrentPosition,
        ];
        previousAsCurrentPosition -= this.CARD_MOVEMENT_WIDTH;
      }

      let cardSelectorCarouselNextAsCurrentAI = gsap.timeline({
        paused: true,
        duration: this.CARD_SELECTION_ANIMATION_DURATION,
        ease: "power3.inOut",
        autoRemoveChildren: false,
        smoothChildTiming: true,
      });
      cardSelectorCarouselNextAsCurrentAI.eventCallback("onComplete", () => {
        console.log(
          "onComplete cardSelectorCarouselNextAsCurrentAI",
          cardIndex
        );
        this.selectedCardIndex = -1;
        if (cardIndex > 0) {
          this.cardSelectorCarouselPreviousAsCurrentAIs[cardIndex - 1]
            .pause()
            .seek(0);
        }
        this.activeCardIndex = cardIndex;
        this.doResetScroll();
      });
      cardSelectorCarouselNextAsCurrentAI.eventCallback(
        "onReverseComplete",
        () => {
          console.log(
            "onReverseComplete cardSelectorCarouselNextAsCurrentAI",
            cardIndex
          );
          this.selectedCardIndex = -1;
          cardSelectorCarouselNextAsCurrentAI.reversed(false);
          cardSelectorCarouselNextAsCurrentAI.pause().seek(0);
          this.doResetScroll();
        }
      );

      cardSelectorCarouselNextAsCurrentAI.fromTo(
        ".card-selector",
        { x: translatePositionNextAsCurrent[0] },
        { x: translatePositionNextAsCurrent[1] },
        0
      );
      //card-bg-selector-holder
      let translatePositionBgNextAsCurrent;
      if (cardIndex == 0) {
        translatePositionBgNextAsCurrent = [
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["height"],
            },
          },
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["height"],
            },
          },
        ];
      } else {
        translatePositionBgNextAsCurrent = [
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex - 1]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex - 1]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex - 1]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex - 1]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex - 1]["height"],
            },
          },
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["height"],
            },
          },
        ];
      }
      cardSelectorCarouselNextAsCurrentAI.fromTo(
        ".card-bg-selector .card-bg-selector-holder",
        translatePositionBgNextAsCurrent[0],
        translatePositionBgNextAsCurrent[1],
        0
      );

      //svg
      let translatePositionBgNextAsCurrentSvg;
      if (cardIndex == 0) {
        //translatePositionBgNextAsCurrentSvg = [{ attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["heightVB"] } }, { attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["heightVB"] } }];
        translatePositionBgNextAsCurrentSvg = [
          { attr: { viewBox: CARD_BG_SVGS[cardIndex]["viewBox"] } },
          { attr: { viewBox: CARD_BG_SVGS[cardIndex]["viewBox"] } },
        ];
      } else {
        //translatePositionBgNextAsCurrentSvg = [{ attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex - 1]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex - 1]["heightVB"] } }, { attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["heightVB"] } }];
        translatePositionBgNextAsCurrentSvg = [
          { attr: { viewBox: CARD_BG_SVGS[cardIndex - 1]["viewBox"] } },
          { attr: { viewBox: CARD_BG_SVGS[cardIndex]["viewBox"] } },
        ];
      }
      cardSelectorCarouselNextAsCurrentAI.fromTo(
        ".card-bg-selector svg",
        translatePositionBgNextAsCurrentSvg[0],
        translatePositionBgNextAsCurrentSvg[1],
        0
      );

      let pathIds = [];

      //svg g path[]

      if (cardIndex == 0) {
        pathIds.forEach((pathId, i) => {
          cardSelectorCarouselNextAsCurrentAI.fromTo(
            ".card-bg-selector svg g path#" + pathId,
            {
              attr: {
                transform: CARD_BG_SVGS[cardIndex]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" + pathId + "_" + cardIndex,
            },
            {
              attr: {
                transform: CARD_BG_SVGS[cardIndex]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" + pathId + "_" + cardIndex,
            },
            0
          );
        });
      } else {
        pathIds.forEach((pathId, i) => {
          cardSelectorCarouselNextAsCurrentAI.fromTo(
            ".card-bg-selector svg g path#" + pathId,
            {
              attr: {
                transform:
                  CARD_BG_SVGS[cardIndex - 1]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" +
                pathId +
                "_" +
                (cardIndex - 1),
            },
            {
              attr: {
                transform: CARD_BG_SVGS[cardIndex]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" + pathId + "_" + cardIndex,
            },
            0
          );
        });
      }

      this.cardSelectorCarouselNextAsCurrentAIs.push(
        cardSelectorCarouselNextAsCurrentAI
      );

      let cardSelectorCarouselPreviousAsCurrentAI = gsap.timeline({
        paused: true,
        duration: this.CARD_SELECTION_ANIMATION_DURATION,
        ease: "power3.inOut",
        autoRemoveChildren: false,
        smoothChildTiming: true,
      });
      cardSelectorCarouselPreviousAsCurrentAI.eventCallback(
        "onComplete",
        () => {
          console.log(
            "onComplete cardSelectorCarouselPreviousAsCurrentAI",
            cardIndex
          );
          this.selectedCardIndex = -1;
          if (cardIndex < this.cards.length - 1) {
            this.cardSelectorCarouselNextAsCurrentAIs[cardIndex + 1]
              .pause()
              .seek(0);
          }
          this.activeCardIndex = cardIndex;
          this.doResetScroll();
        }
      );
      cardSelectorCarouselPreviousAsCurrentAI.eventCallback(
        "onReverseComplete",
        () => {
          console.log(
            "onReverseComplete cardSelectorCarouselPreviousAsCurrentAI",
            cardIndex
          );
          this.selectedCardIndex = -1;
          cardSelectorCarouselPreviousAsCurrentAI.reversed(false);
          cardSelectorCarouselPreviousAsCurrentAI.pause().seek(0);
          this.doResetScroll();
        }
      );

      cardSelectorCarouselPreviousAsCurrentAI.fromTo(
        ".card-selector",
        { x: translatePositionPreviousAsCurrent[0] },
        { x: translatePositionPreviousAsCurrent[1] },
        0
      );
      //card-bg-selector-holder
      let translatePositionBgPreviousAsCurrent;
      if (cardIndex == this.cards.length - 1) {
        translatePositionBgPreviousAsCurrent = [
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["height"],
            },
          },
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["height"],
            },
          },
        ];
      } else {
        translatePositionBgPreviousAsCurrent = [
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex + 1]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex + 1]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex + 1]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex + 1]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex + 1]["height"],
            },
          },
          {
            css: {
              x: CARD_BG_TRANSLATE_TWEENS[cardIndex]["x"],
              y: CARD_BG_TRANSLATE_TWEENS[cardIndex]["y"],
              rotation: CARD_BG_TRANSLATE_TWEENS[cardIndex]["rotation"],
              width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["width"],
              height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["height"],
            },
          },
        ];
      }
      cardSelectorCarouselPreviousAsCurrentAI.fromTo(
        ".card-bg-selector .card-bg-selector-holder",
        translatePositionBgPreviousAsCurrent[0],
        translatePositionBgPreviousAsCurrent[1],
        0
      );

      //svg
      let translatePositionBgPreviousAsCurrentSvg;
      if (cardIndex == this.cards.length - 1) {
        //translatePositionBgPreviousAsCurrentSvg = [{ attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["heightVB"] } }, { attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["heightVB"] } }];
        translatePositionBgPreviousAsCurrentSvg = [
          { attr: { viewBox: CARD_BG_SVGS[cardIndex]["viewBox"] } },
          { attr: { viewBox: CARD_BG_SVGS[cardIndex]["viewBox"] } },
        ];
      } else {
        //translatePositionBgPreviousAsCurrentSvg = [{ attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex + 1]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex + 1]["heightVB"] } }, { attr: { width: CARD_BG_TRANSLATE_TWEENS[cardIndex]["widthVB"], height: CARD_BG_TRANSLATE_TWEENS[cardIndex]["heightVB"] } }];
        translatePositionBgPreviousAsCurrentSvg = [
          { attr: { viewBox: CARD_BG_SVGS[cardIndex + 1]["viewBox"] } },
          { attr: { viewBox: CARD_BG_SVGS[cardIndex]["viewBox"] } },
        ];
      }
      cardSelectorCarouselPreviousAsCurrentAI.fromTo(
        ".card-bg-selector svg",
        translatePositionBgPreviousAsCurrentSvg[0],
        translatePositionBgPreviousAsCurrentSvg[1],
        0
      );

      //svg g path[]
      if (cardIndex == this.cards.length - 1) {
        pathIds.forEach((pathId, i) => {
          //cardSelectorCarouselPreviousAsCurrentAI.fromTo(".card-bg-selector svg g path#" + pathId, { morphSVG: ".card-bg-selector svg g path#" + pathId + "_" + cardIndex }, { morphSVG: ".card-bg-selector svg g path#" + pathId + "_" + cardIndex }, 0);
          cardSelectorCarouselPreviousAsCurrentAI.fromTo(
            ".card-bg-selector svg g path#" + pathId,
            {
              attr: {
                transform: CARD_BG_SVGS[cardIndex]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" + pathId + "_" + cardIndex,
            },
            {
              attr: {
                transform: CARD_BG_SVGS[cardIndex]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" + pathId + "_" + cardIndex,
            },
            0
          );
        });
      } else {
        pathIds.forEach((pathId, i) => {
          //cardSelectorCarouselPreviousAsCurrentAI.fromTo(".card-bg-selector svg g path#" + pathId, { morphSVG: ".card-bg-selector svg g path#" + pathId + "_" + (cardIndex + 1) }, { morphSVG: ".card-bg-selector svg g path#" + pathId + "_" + cardIndex }, 0);
          cardSelectorCarouselPreviousAsCurrentAI.fromTo(
            ".card-bg-selector svg g path#" + pathId,
            {
              attr: {
                transform:
                  CARD_BG_SVGS[cardIndex + 1]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" +
                pathId +
                "_" +
                (cardIndex + 1),
            },
            {
              attr: {
                transform: CARD_BG_SVGS[cardIndex]["g"]["path"][i]["transform"],
              },
              morphSVG:
                ".card-bg-selector svg g path#" + pathId + "_" + cardIndex,
            },
            0
          );
        });
      }

      this.cardSelectorCarouselPreviousAsCurrentAIs.push(
        cardSelectorCarouselPreviousAsCurrentAI
      );
    }
  }

  teardownCarouselAnimation() {
    this.calculateDimensions();

    this.teardownCarouselCardChangeAnimation();
    this.cardSelectorCarouselPreviousAsCurrentAIs.forEach((item) => {
      if (item) {
        item.kill();
        item = null;
      }
    });
    this.cardSelectorCarouselNextAsCurrentAIs.forEach((item) => {
      if (item) {
        item.kill();
        item = null;
      }
    });
  }

  seekFirstCardBounceCarouselAnimation(progress) {
    let seekTime =
      (this.CARD_SELECTION_ANIMATION_DURATION / 10.0) * (progress / 100);
    console.log("Seek", seekTime);
    this.cardSelectorCarouselFirstCardAI.pause().seek(seekTime);
  }

  seekLastCardBounceCarouselAnimation(progress) {
    let seekTime =
      (this.CARD_SELECTION_ANIMATION_DURATION / 10.0) * (progress / 100);
    console.log("Seek", seekTime);
    this.cardSelectorCarouselLastCardAI.pause().seek(seekTime);
  }

  seekNextAsCurrentCarouselAnimation(index, progress) {
    let seekTime = this.CARD_SELECTION_ANIMATION_DURATION * (progress / 100);
    console.log("Seek", seekTime);
    let animeInstances = [];
    animeInstances.push(this.cardSelectorCarouselNextAsCurrentAIs[index]);
    animeInstances.push(this.nextAsCurrentCardTimeline);
    animeInstances.forEach((item) => {
      if (item) {
        //item.pause().seek(seekTime);
        item.pause().totalProgress(progress / 100.0);
      }
    });
  }

  seekPreviousAsCurrentCarouselAnimation(index, progress) {
    let seekTime = this.CARD_SELECTION_ANIMATION_DURATION * (progress / 100);
    console.log("Seek", seekTime);
    let animeInstances = [];
    animeInstances.push(this.cardSelectorCarouselPreviousAsCurrentAIs[index]);
    animeInstances.push(this.previousAsCurrentCardTimeline);
    animeInstances.forEach((item) => {
      if (item) {
        //item.pause().seek(seekTime);
        item.pause().totalProgress(progress / 100.0);
      }
    });
  }

  updateCarouselOffsetProgress(anim) {}

  getCaraouselSwipeProgress(index) {
    let OVERVIEW_WIDTH = toVw(35);
    let CARD_MARGIN = toVw(20);
    let CARD_WIDTH = toVw(214);
    let NEWACCOUNT_WIDTH = toVw(64);
    let offsetPostion =
      index == 0
        ? 0
        : Math.floor(
          OVERVIEW_WIDTH + (CARD_MARGIN + CARD_WIDTH) * index - CARD_MARGIN
        );
    let progress = Math.abs(
      (offsetPostion / this.TOTAL_CARD_SELECTOR_WIDTH) * 100
    );
    return progress;
  }

  getCaraouselPanBounceProgress(deltaX) {
    let progress = Math.abs((deltaX / this.CARD_MOVEMENT_WIDTH) * 100);
    return progress;
  }
  getCaraouselPanProgress(deltaX) {
    let progress = Math.abs((deltaX / this.CARD_PROGRESS_MOVEMENT_WIDTH) * 100);
    return progress;
  }

  swipeLeftHandler($event, index) {
    console.log("Swipe Left", index, this.activeCardIndex);

    if (this.playInProgress) {
      console.log("Swipe Left Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (!(index == this.activeCardIndex || index == this.activeCardIndex + 1)) {
      console.log("Swipe Left Index Not Eligible For Swipe");
      return;
    }

    if (index == this.activeCardIndex + 1) {
      console.log("Swipe Left Accepted Next Card");
      this.playInProgress = true;
      this.swipedCardIndex = index;
      this.cardSelectorCarouselNextAsCurrentAIs[index].play();
      this.nextAsCurrentCardTimeline.play();
    }

    if (index == this.activeCardIndex) {
      if (index < this.cards.length - 1) {
        console.log("Swipe Left Accepted Active Card");
        this.playInProgress = true;
        this.swipedCardIndex = index;
        this.cardSelectorCarouselNextAsCurrentAIs[index + 1].play();
        this.nextAsCurrentCardTimeline.play();
      } else {
        console.log("Swipe Left Rejected Last Card");
        this.cardSelectorCarouselLastCardAI.reverse();
      }
    }
  }

  swipeRightHandler($event, index) {
    console.log("Swipe Right", index, this.activeCardIndex);
    if (this.playInProgress) {
      console.log(
        "Swipe Right Index Not Eligible For Swipe - Play In Progress"
      );
      return;
    }

    if (!(index == this.activeCardIndex || index == this.activeCardIndex - 1)) {
      console.log("Swipe Right Index Not Eligible For Swipe");
      return;
    }
    if (index == this.activeCardIndex - 1) {
      console.log("Swipe Right Accepted Previous Card");
      this.playInProgress = true;
      this.swipedCardIndex = index;
      this.cardSelectorCarouselPreviousAsCurrentAIs[index].play();
      this.previousAsCurrentCardTimeline.play();
    }

    if (index == this.activeCardIndex) {
      if (index > 0) {
        console.log("Swipe Right Accepted Active Card");
        this.playInProgress = true;
        this.swipedCardIndex = index;
        this.cardSelectorCarouselPreviousAsCurrentAIs[index - 1].play();
        this.previousAsCurrentCardTimeline.play();
      } else {
        console.log("Swipe Right Rejected First Card");
        this.cardSelectorCarouselFirstCardAI.reverse();
      }
    }
  }

  touchStartHandler($event, index) {
    console.log("Touch Start", index, this.activeCardIndex);
    this.touchCardIndex = index;
  }

  touchEndHandler($event, index) {
    console.log("Touch End", index, this.activeCardIndex);
    this.touchCardIndex = -1;
  }

  panStartHandler($event, index) {
    console.log("Pan Start", index, this.activeCardIndex, $event.center.x);
    if (this.playInProgress) {
      console.log("Pan Start Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (
      !(
        index == this.activeCardIndex ||
        index == this.activeCardIndex + 1 ||
        index == this.activeCardIndex - 1
      )
    ) {
      console.log("Pan Start Index Not Eligible For Pan");
      return;
    }
    if (this.selectedCardIndex == -1) {
      this.playInProgress = false;
      this.panCardIndex = index;
      this.selectedCardIndex = index;
      this.stopScroll = true;
    }
  }

  panEndHandler($event, index) {
    console.log(
      "Pan End",
      index,
      this.activeCardIndex,
      this.selectedCardIndex,
      this.panCardIndex,
      $event.deltaX
    );

    if (index == this.swipedCardIndex) {
      this.swipedCardIndex = -1;
      console.log("Pan End Skipped Pan End On Swipe Event");
      return;
    }
    if (this.playInProgress) {
      console.log("Pan End Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (
      !(
        index == this.activeCardIndex ||
        index == this.activeCardIndex + 1 ||
        index == this.activeCardIndex - 1
      )
    ) {
      console.log("Pan End Index Not Eligible For Pan");
      this.doResetScroll();
      return;
    }

    if (this.panCardIndex != this.selectedCardIndex) {
      console.log("Pan End Skipped Pan End On Mismatch Of Pan Card");
      this.panCardIndex = -1;
      this.doResetScroll();
      return;
    }
    let panPercentage = this.calculatePanDistancePercentage($event);
    console.log(
      "Pan End",
      index,
      this.selectedCardIndex,
      $event.deltaX,
      panPercentage
    );

    if (index !== this.activeCardIndex) {
      if (panPercentage >= 0) {
        if (index < this.activeCardIndex && $event.deltaX >= 0) {
          if (panPercentage >= 50) {
            console.log("Pan End - Previous Card To Active Play");
            this.playInProgress = true;
            this.cardSelectorCarouselPreviousAsCurrentAIs[index].play();
            this.previousAsCurrentCardTimeline.play();
          } else {
            console.log("Pan End - Previous Card To Active Reverse");
            this.playInProgress = true;
            this.cardSelectorCarouselPreviousAsCurrentAIs[index].reverse();
            this.previousAsCurrentCardTimeline.reverse();
          }
        }

        if (index > this.activeCardIndex && $event.deltaX <= 0) {
          if (panPercentage >= 50) {
            console.log("Pan End - Next Card To Active Play");
            this.playInProgress = true;
            this.cardSelectorCarouselNextAsCurrentAIs[index].play();
            this.nextAsCurrentCardTimeline.play();
          } else {
            console.log("Pan End - Next Card To Active Reverse");
            this.playInProgress = true;
            this.cardSelectorCarouselNextAsCurrentAIs[index].reverse();
            this.nextAsCurrentCardTimeline.reverse();
          }
        }
      }
    }
    if (index == this.activeCardIndex) {
      console.log(
        "Pan End  - Active Card",
        index,
        this.activeCardIndex,
        this.selectedCardIndex,
        $event.deltaX,
        panPercentage
      );
      if (panPercentage >= 0) {
        if ($event.deltaX >= 0) {
          if (index > 0) {
            if (panPercentage >= 50) {
              console.log("Pan End - Active Card To Previous Play");
              this.playInProgress = true;
              this.cardSelectorCarouselPreviousAsCurrentAIs[index - 1].play();
              this.previousAsCurrentCardTimeline.play();
            } else {
              console.log("Pan End - Active Card To Previous Reverse");
              this.playInProgress = true;
              this.cardSelectorCarouselPreviousAsCurrentAIs[
                index - 1
              ].reverse();
              this.previousAsCurrentCardTimeline.reverse();
            }
          } else {
            console.log("Pan End - First Card No Movement End");
            this.cardSelectorCarouselFirstCardAI.reverse();
          }
        } else if ($event.deltaX < 0) {
          if (index < this.cards.length - 1) {
            if (panPercentage >= 50) {
              console.log("Pane End - Active Card To Next Play");
              this.playInProgress = true;
              this.cardSelectorCarouselNextAsCurrentAIs[index + 1].play();
              this.nextAsCurrentCardTimeline.play();
            } else {
              console.log("Pan End - Active Card To Next Reverse");
              this.playInProgress = true;
              this.cardSelectorCarouselNextAsCurrentAIs[index + 1].reverse();
              this.nextAsCurrentCardTimeline.reverse();
            }
          } else {
            console.log("Pan End - Last Card No Movement End");
            this.cardSelectorCarouselLastCardAI.reverse();
          }
        }
      }
    }
    this.panCardIndex = -1;
  }

  calculatePanDistancePercentage($event) {
    let panDelta = $event.deltaX;
    let panPercentage =
      (Math.abs(panDelta) * 100) / this.CARD_PROGRESS_MOVEMENT_WIDTH;
    return panPercentage;
  }

  panLeftHandler($event, index) {
    //console.log("Pan Left, index, this.activeCardIndex, this.selectedCardIndex, $event.deltaX);
    if (this.playInProgress) {
      //console.log("Pan Left Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (
      !(
        index == this.activeCardIndex ||
        index == this.activeCardIndex + 1 ||
        index == this.activeCardIndex - 1
      )
    ) {
      //console.log("Pan Left Index Not Eligible For Pan");
      return;
    }

    if (this.panCardIndex != this.selectedCardIndex) {
      //console.log("Pan Left Skipped - Mismatch Selected Cards", index, this.panCardIndex, this.selectedCardIndex);
      return;
    }

    if (index == this.swipedCardIndex) {
      //console.log("Pan Left Skipped - Pan Left On Swipe Event", index, this.swipedCardIndex);
      return;
    }

    let panPercentage = this.calculatePanDistancePercentage($event);
    //console.log("Pan Left Progress", index, panPercentage);

    if (index != this.activeCardIndex) {
      if (index > this.activeCardIndex) {
        if ($event.deltaX <= 0 && panPercentage > 0 && panPercentage < 100) {
          //console.log("Pan Left - Next Card as Active Seek Play");
          let progress = this.getCaraouselPanProgress($event.deltaX);
          this.seekNextAsCurrentCarouselAnimation(index, progress);
        }
      } else if (index < this.activeCardIndex) {
        if ($event.deltaX >= 0 && panPercentage > 0 && panPercentage < 100) {
          //console.log("Pan Left - Previous Card as Active Seek Reverse");
          let progress = this.getCaraouselPanProgress($event.deltaX);
          this.seekPreviousAsCurrentCarouselAnimation(index, progress);
        }
      }
    }

    if (index == this.activeCardIndex) {
      if ($event.deltaX >= 0) {
        if (index > 0) {
          //console.log("Pan Left - Active Card To Previous Seek Reverse");
          if (panPercentage > 0 && panPercentage < 100) {
            let progress = this.getCaraouselPanProgress($event.deltaX);
            this.seekPreviousAsCurrentCarouselAnimation(index - 1, progress);
          }
        } else {
          //console.log("Pan Left - No Active Card To Previous Reverse On First Card");
        }
      } else if ($event.deltaX < 0) {
        if (index < this.cards.length - 1) {
          if (panPercentage > 0 && panPercentage < 100) {
            //console.log("Pan Left - Active Card To Next Seek Play");
            let progress = this.getCaraouselPanProgress($event.deltaX);
            this.seekNextAsCurrentCarouselAnimation(index + 1, progress);
          }
        } else {
          //console.log("Pan Left - No Active Card To Next On Last Card - Trigger Bounce Timeline");
          //End Bouncing Effect
          let progress = this.getCaraouselPanBounceProgress($event.deltaX);
          this.seekLastCardBounceCarouselAnimation(progress);
        }
      }
    }
  }

  panRightHandler($event, index) {
    console.log(
      "Pan Right",
      index,
      this.activeCardIndex,
      this.selectedCardIndex,
      $event.deltaX
    );
    if (this.playInProgress) {
      console.log("Pan Right Index Not Eligible For Swipe - Play In Progress");
      return;
    }

    if (
      !(
        index == this.activeCardIndex ||
        index == this.activeCardIndex + 1 ||
        index == this.activeCardIndex - 1
      )
    ) {
      console.log("Pan Right Index Not Eligible For Pan");
      return;
    }

    if (this.panCardIndex != this.selectedCardIndex) {
      console.log(
        "Pan Right Skipped - Mismatch Selected Cards",
        index,
        this.panCardIndex,
        this.activeCardIndex
      );
      return;
    }

    if (index == this.swipedCardIndex) {
      console.log(
        "Pan Right Skipped - Pan Right On Swipe Event",
        index,
        this.swipedCardIndex
      );
      return;
    }

    let panPercentage = this.calculatePanDistancePercentage($event);
    console.log("Pan Right Progress", index, panPercentage);

    if (index !== this.activeCardIndex) {
      if (index > this.activeCardIndex) {
        if ($event.deltaX <= 0 && panPercentage > 0 && panPercentage < 100) {
          console.log("Pan Right - Next Card as Active Seek Reverse");
          let progress = this.getCaraouselPanProgress($event.deltaX);
          this.seekNextAsCurrentCarouselAnimation(index, progress);
        }
      } else if (index < this.activeCardIndex) {
        if ($event.deltaX >= 0 && panPercentage > 0 && panPercentage < 100) {
          console.log("Pan Right - Previous Card as Active Seek Play");
          let progress = this.getCaraouselPanProgress($event.deltaX);
          this.seekPreviousAsCurrentCarouselAnimation(index, progress);
        }
      }
    }

    if (index == this.activeCardIndex) {
      if ($event.deltaX >= 0) {
        if (index > 0) {
          if (panPercentage > 0 && panPercentage < 100) {
            console.log("Pan Right - Active Card To Previous Seek Play");
            let progress = this.getCaraouselPanProgress($event.deltaX);
            this.seekPreviousAsCurrentCarouselAnimation(index - 1, progress);
          }
        } else {
          console.log(
            "Pan Right - No Active Card To Previous On First Card - Trigger Bounce Timeline"
          );
          //Start Bouncing Effect
          let progress = this.getCaraouselPanBounceProgress($event.deltaX);
          this.seekFirstCardBounceCarouselAnimation(progress);
        }
      } else if ($event.deltaX < 0) {
        if (index < this.cards.length - 1) {
          if (panPercentage > 0 && panPercentage < 100) {
            console.log("Pan Right - Active Card To Next Seek Reverse");
            let progress = this.getCaraouselPanProgress($event.deltaX);
            this.seekNextAsCurrentCarouselAnimation(index + 1, progress);
          }
        } else {
          console.log("Pan Right - No Active To Next On Last Card");
        }
      }
    }
  }

  swipeUpHandler($event) {
    console.log("Swipe Up");
  }

  swipeDownHandler($event) {
    console.log("Swipe Down");
  }

  panUpHandler($event) {
    console.log("Pan Up");
  }

  panDownHandler($event) {
    console.log("Pan Down");
  }

  ngOnInit() {
    if (this.isMobile && this.deviceService.os.toLowerCase() == "android" && this.device.platform.toLowerCase() == "android") {
     
       this.mobileService.checkNFCPresent();
    }

    this._appCommon.showLangSwitcher = true;
    this.cards = [];
    for (var j = 0; j < appStartLinks.length; j++) {
      if (this._appCommon.isMobile()) {
        this.cards.push(appStartLinks[j]);
      } else {
        this.cards.push(appStartLinks[j]);
      }
    }
    this.activeCardIndex = this._appCommon.isMobile()
      ? this.initialCardMobile
      : this.initialCardDesktop;

    this.stackCards = [];
    for (var j = 0; j < appStartProducts.length; j++) {
      this.stackCards.push(appStartProducts[j]);
    }
    this.activeStackCardIndex = 0;
    document.body.classList.add("faq");
    document.body.classList.add("stips");
  }

  ngAfterViewInit() {
    /*SANTHOSH 12-DEC-2021 BEGIN*/
    if (this.services.isMobile()) {
      this.setupAnimations();
      setTimeout(() => {
        this.cardSelectorCarouselNextAsCurrentAIs[this.activeCardIndex].play();
      });
    }

    this.setupStackCardAnimation();
    // let loadBannerAds$ = new Observable<boolean>((observer) => {
    // setTimeout(async () => {
    //   this._customerService
    //     .fetchPreloginList("PRELOGINAD")
    //     .subscribe((res) => {
    //       this.preLoginData = res;
    //       console.log("AdsList", res);
    //     });
    // });
    //});

    // loadBannerAds$.subscribe((res) => {
    //   console.log("AdsList", res);
    // });
    /*SANTHOSH 12-DEC-2021 END*/
    this._nativeStorage
      .retriveData("deviceAuth")
      .then((value) => {
        console.log("deviceAuthretriveData=>", value);
        this._appCommon.isDeviceAuthRegistered = true;
        this._appCommon.isMpinRegistered = true;
      })
      .catch((error) => {
        this._nativeStorage
          .retriveData("mpin")
          .then((value) => {
            this._appCommon.isMpinRegistered = true;
          })
          .catch((error) => {});
      });
    // document.querySelector<HTMLElement>('ux-app-start-card .active-card').click()
  }

  ngOnDestroy() {
    this._appCommon.showLangSwitcher = false;
    /*SANTHOSH 12-DEC-2021 BEGIN*/
    if (this.services.isMobile()) {
      this.teardownAnimations();
    }
    /*SANTHOSH 12-DEC-2021 END*/
    if (this.services.greenifyEnabled) {
      $(".desktop-layout").removeClass("greenify");
    }
    document.body.classList.remove("faq");
    document.body.classList.remove("stips");
  }

  ngDoCheck() {
    /*SANTHOSH 12-DEC-2021 BEGIN*/
    if (this.services.isMobile()) {
      if (this.oldCardIndex != this.activeCardIndex) {
        console.log("ngDoCheck", this.oldCardIndex, this.activeCardIndex);
      }
    }
    /*SANTHOSH 12-DEC-2021 END*/
  }

  ngAfterContentChecked() {
    /*SANTHOSH 12-DEC-2021 BEGIN*/
    if (this.services.isMobile()) {
      if (this.oldCardIndex != this.activeCardIndex) {
        console.log(
          "ngAfterContentChecked",
          this.oldCardIndex,
          this.activeCardIndex
        );
      }
    }
    /*SANTHOSH 12-DEC-2021 END*/
  }

  canviewNotifi = true;
  ngAfterViewChecked() {
    this.canviewNotifi = false;
    /*if (localStorage.getItem("dontPromptPushPermission") == "1" || !this.services.mobile.isHybrid()) {
      this.canviewNotifi = false;
    }
    else {
      this.canviewNotifi = true;
    }*/

    /*SANTHOSH 12-DEC-2021 BEGIN*/
    if (this.services.isMobile()) {
      if (this.oldCardIndex != this.activeCardIndex) {
        console.log(
          "ngAfterViewChecked",
          this.oldCardIndex,
          this.activeCardIndex
        );
        this.teardownCarouselCardChangeAnimation();
        this.setupCarouselCardChangeAnimation();
        this.oldCardIndex = this.activeCardIndex;
      }
      if (this.resetScroll) {
        this.playInProgress = false;
        this.stopScroll = false;
        this.resetScroll = false;
      }
    }
    if (this.oldStackCardIndex != this.activeStackCardIndex) {
      console.log(
        "Stack ngAfterViewChecked",
        this.oldStackCardIndex,
        this.activeStackCardIndex
      );
      this.teardownStackCardAnimation();
      this.setupStackCardAnimation();
      this.oldStackCardIndex = this.activeStackCardIndex;
    }
    if (this.resetStackScroll) {
      this.stackPlayInProgress = false;
      this.stopStackScroll = false;
      this.resetStackScroll = false;
    }
    /*SANTHOSH 12-DEC-2021 END*/
  }

  doResetScroll() {
    this.selectedCardIndex = -1;
    this.playInProgress = false;
    this.resetScroll = true;
    this.changeDetectorRef.markForCheck();
    this.applicationRef.tick();
  }

  setupCarouselSwiperAnimation() {
    var swiper = new Swiper(".app-start-swiper", {
      grabCursor: true,
      slidesPerView: 2,
      spaceBetween: toVw(20),
      watchSlidesProgress: true,
      on: {
        slideChange: (swiper) => {
          console.log("Slide Changed", swiper.activeIndex);
          this.activeCardIndex = swiper.activeIndex;
        },
        progress: (swiper, progress) => {
          console.log(progress);
        },
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 3,
        slideShadows: false,
      },
    });
  }

  setupAnimations() {
    //this.setupCarouselAnimation();
    this.teardownAnimations();
    this.setupCarouselAnimation();
    this.setupCarouselCardChangeAnimation();
  }

  teardownAnimations() {
    this.teardownCarouselAnimation();
    this.teardownCarouselCardChangeAnimation();
    this.teardownStackCardAnimation();
  }

  getTouchCardText() {
    return this.touchCardIndex == -1
      ? this.selectedCardIndex == -1
        ? this.cards[this.activeCardIndex].description
        : this.cards[this.selectedCardIndex].description
      : this.cards[this.touchCardIndex].description;
  }

  stackCards = [];

  selectedStackCardIndex = -1;

  activeStackCardIndex = 0;

  private oldStackCardIndex = 0;

  private swipedStackCardIndex = -1;

  private panStackCardIndex = -1;

  private touchStackCardIndex = -1;

  private stackPlayInProgress = false;

  private stopStackScroll = false;

  private resetStackScroll = false;

  private stackCardSwipeRightAI;

  private stackCardSwipeLeftAI;

  setupStackCardAnimation() {
    this.stackCardSwipeRightAI = gsap.timeline({
      paused: true,
      duration: this.STACK_CARD_SELECTION_ANIMATION_DURATION,
      ease: "power1.inOut",
    });
    this.stackCardSwipeRightAI.eventCallback("onComplete", () => {
      console.log("onComplete stackCardSwipeRightAI");
      this.activeStackCardIndex = this.activeStackCardIndex + 1;
      this.doResetStackScroll();
    });
    this.stackCardSwipeRightAI.eventCallback("onReverseComplete", () => {
      console.log("onReverseComplete stackCardSwipeRightAI");
      this.doResetStackScroll();
    });
    if (this.activeStackCardIndex < this.stackCards.length - 2) {
      this.stackCardSwipeRightAI.fromTo(
        ".card-stack .card-stack-cards ux-app-start-stack-card.active-card-plus-one-plus",
        { css: { x: toVwU(8), y: toVhU(37), rotation: -6, opacity: 1 } },
        { css: { x: toVwU(20), y: toVhU(27), rotation: -3, opacity: 1 } },
        0
      );
    }
    if (this.activeStackCardIndex < this.stackCards.length - 1) {
      this.stackCardSwipeRightAI.fromTo(
        ".card-stack .card-stack-cards ux-app-start-stack-card.active-card-plus-one",
        { css: { x: toVwU(20), y: toVhU(27), rotation: -3, opacity: 1 } },
        { css: { x: toVwU(32), y: toVhU(17), rotation: 0, opacity: 1 } },
        0
      );
      this.stackCardSwipeRightAI.fromTo(
        ".card-stack .card-stack-indicator .active-card-plus-one",
        { css: { width: toVwU(7) } },
        { css: { width: toVwU(19) } },
        0
      );
    }
    this.stackCardSwipeRightAI.fromTo(
      ".card-stack .card-stack-cards ux-app-start-stack-card.active-card",
      { css: { x: toVwU(32), y: toVhU(17), rotation: 0, opacity: 1 } },
      { css: { x: toVwU(164), y: toVhU(-43), rotation: 18, opacity: 0 } },
      0
    );
    if (this.activeStackCardIndex > 0) {
      this.stackCardSwipeRightAI.fromTo(
        ".card-stack .card-stack-cards ux-app-start-stack-card.active-card-minus-one",
        { css: { x: toVwU(164), y: toVhU(-43), rotation: 18, opacity: 0 } },
        { css: { x: toVwU(176), y: toVhU(-53), rotation: 21, opacity: 0 } },
        0
      );
    }

    this.stackCardSwipeRightAI.fromTo(
      ".card-stack .card-stack-indicator .active-card",
      { css: { width: toVwU(19) } },
      { css: { width: toVwU(7) } },
      0
    );

    this.stackCardSwipeLeftAI = gsap.timeline({
      paused: true,
      duration: this.STACK_CARD_SELECTION_ANIMATION_DURATION,
      ease: "power1.inOut",
    });
    this.stackCardSwipeLeftAI.eventCallback("onComplete", () => {
      console.log("onComplete stackCardSwipeLeftAI");
      this.activeStackCardIndex = this.activeStackCardIndex - 1;
      this.doResetStackScroll();
    });
    this.stackCardSwipeLeftAI.eventCallback("onReverseComplete", () => {
      console.log("onReverseComplete stackCardSwipeLeftAI");
      this.doResetStackScroll();
    });
    if (this.activeStackCardIndex > 1) {
      this.stackCardSwipeLeftAI.fromTo(
        ".card-stack .card-stack-cards ux-app-start-stack-card.active-card-minus-one-minus",
        { css: { x: toVwU(176), y: toVhU(-53), rotation: 21, opacity: 0 } },
        { css: { x: toVwU(164), y: toVhU(-43), rotation: 18, opacity: 0 } },
        0
      );
    }
    if (this.activeStackCardIndex > 0) {
      this.stackCardSwipeLeftAI.fromTo(
        ".card-stack .card-stack-cards ux-app-start-stack-card.active-card-minus-one",
        { css: { x: toVwU(164), y: toVhU(-43), rotation: 18, opacity: 0 } },
        { css: { x: toVwU(32), y: toVhU(17), rotation: 0, opacity: 1 } },
        0
      );
      this.stackCardSwipeLeftAI.fromTo(
        ".card-stack .card-stack-indicator .active-card-minus-one",
        { css: { width: toVwU(7) } },
        { css: { width: toVwU(19) } },
        0
      );
    }
    this.stackCardSwipeLeftAI.fromTo(
      ".card-stack .card-stack-cards ux-app-start-stack-card.active-card",
      { css: { x: toVwU(32), y: toVhU(17), rotation: 0, opacity: 1 } },
      { css: { x: toVwU(20), y: toVhU(27), rotation: -3, opacity: 1 } },
      0
    );
    if (this.activeStackCardIndex < this.stackCards.length - 1) {
      this.stackCardSwipeLeftAI.fromTo(
        ".card-stack .card-stack-cards ux-app-start-stack-card.active-card-plus-one",
        { css: { x: toVwU(20), y: toVhU(27), rotation: -3, opacity: 1 } },
        { css: { x: toVwU(8), y: toVhU(37), rotation: -6, opacity: 1 } },
        0
      );
    }

    this.stackCardSwipeLeftAI.fromTo(
      ".card-stack .card-stack-indicator .active-card",
      { css: { width: toVwU(19) } },
      { css: { width: toVwU(7) } },
      0
    );
  }

  teardownStackCardAnimation() {
    if (this.stackCardSwipeRightAI) {
      this.stackCardSwipeRightAI.kill();
      this.stackCardSwipeRightAI = null;
    }

    if (this.stackCardSwipeLeftAI) {
      this.stackCardSwipeLeftAI.kill();
      this.stackCardSwipeLeftAI = null;
    }
  }

  swipeLeftStackHandler($event, index) {
    console.log("Stack Swipe Left", index, this.activeStackCardIndex);

    if (this.stackPlayInProgress) {
      console.log(
        "Stack Swipe Left Index Not Eligible For Swipe - Play In Progress"
      );
      return;
    }

    if (index != this.activeStackCardIndex - 1) {
      console.log("Swipe Left Index Not Eligible For Swipe");
      return;
    }

    if (index == this.activeStackCardIndex - 1) {
      console.log("Stack Swipe Left Accepted For Hidden Card");
      this.stackPlayInProgress = true;
      this.swipedStackCardIndex = index;
      this.stackCardSwipeLeftAI.play();
    }
  }

  swipeRightStackHandler($event, index) {
    console.log("Stack Swipe Right", index, this.activeStackCardIndex);
    if (this.stackPlayInProgress) {
      console.log(
        "Stack Swipe Right Index Not Eligible For Swipe - Play In Progress"
      );
      return;
    }
    if (index != this.activeStackCardIndex) {
      console.log("Stack Swipe Right Index Not Eligible For Swipe");
      return;
    }
    if (index == this.stackCards.length - 1) {
      console.log("Stack Swipe Right Last Card Not Eligible For Swipe");
      return;
    }
    if (index == this.activeStackCardIndex) {
      console.log("Stack Swipe Right Accepted For Active Card");
      this.stackPlayInProgress = true;
      this.swipedStackCardIndex = index;
      this.stackCardSwipeRightAI.play();
    }
  }

  swipeUpStackHandler($event, index) {
    console.log("Stack Swipe Up");
    this.swipeRightStackHandler($event, index);
  }

  swipeDownStackHandler($event, index) {
    console.log("Stack Swipe Down");
    this.swipeLeftStackHandler($event, index);
  }

  touchStartStackHandler($event, index) {
    console.log("Stack Touch Start", index, this.activeStackCardIndex);
    this.touchStackCardIndex = index;
  }

  touchEndStackHandler($event, index) {
    console.log("Stack Touch End", index, this.activeStackCardIndex);
    this.touchStackCardIndex = -1;
  }

  panStartStackHandler($event, index) {
    console.log(
      "Stack Pan Start",
      index,
      this.activeStackCardIndex,
      $event.center.x
    );
    if (this.stackPlayInProgress) {
      console.log(
        "Stack Pan Start Index Not Eligible For Pan - Play In Progress"
      );
      return;
    }

    if (
      !(
        index == this.activeStackCardIndex ||
        index == this.activeStackCardIndex - 1
      )
    ) {
      console.log("Stack Pan Start Index Not Eligible For Pan");
      return;
    }

    this.stopStackScroll = true;
    this.stackPlayInProgress = false;
    this.panStackCardIndex = index;
    this.selectedStackCardIndex = index;
  }

  panEndStackHandler($event, index) {
    console.log(
      "Stack Pan End",
      index,
      this.activeStackCardIndex,
      this.selectedStackCardIndex,
      this.panStackCardIndex,
      $event.deltaX
    );

    if (index == this.swipedStackCardIndex) {
      this.swipedStackCardIndex = -1;
      console.log("Stack Pan End Skipped Pan End On Swipe Event");
      return;
    }
    if (this.stackPlayInProgress) {
      console.log(
        "Stack Pan End Index Not Eligible For Swipe - Play In Progress"
      );
      return;
    }

    if (this.panStackCardIndex != this.selectedStackCardIndex) {
      console.log("Stack Pan End Skipped On Mismatch Of Selected Card");
      this.panStackCardIndex = -1;
      this.doResetStackScroll();
      return;
    }

    if (
      !(
        index == this.activeStackCardIndex ||
        index == this.activeStackCardIndex - 1
      )
    ) {
      console.log("Stack Pan End Index Not Eligible For Pan");
      this.doResetStackScroll();
      return;
    }

    let panPercentage = this.calculateStackPanDistancePercentage($event);
    console.log(
      "Stack Pan End",
      index,
      this.selectedStackCardIndex,
      $event.deltaX,
      panPercentage
    );

    if (index == this.activeStackCardIndex - 1) {
      if (panPercentage >= 0) {
        if ($event.deltaX <= 0) {
          if (panPercentage >= 50) {
            console.log("Stack Pan End - Swipe Left Active Play");
            this.stackPlayInProgress = true;
            this.stackCardSwipeLeftAI.play();
          } else {
            console.log("Stack Pan End - Swipe Left Active Reverse");
            this.stackPlayInProgress = true;
            this.stackCardSwipeLeftAI.reverse();
          }
        } else {
          console.log("Stack Pan End - Swipe Left Active Reverse 2");
          this.stackPlayInProgress = true;
          this.stackCardSwipeLeftAI.reverse();
          this.doResetStackScroll();
        }
      }
    }

    if (
      index == this.activeStackCardIndex &&
      index < this.stackCards.length - 1
    ) {
      console.log(
        "Pan End  - Active Card",
        index,
        this.activeStackCardIndex,
        this.selectedStackCardIndex,
        $event.deltaX,
        panPercentage
      );
      if (panPercentage >= 0) {
        if ($event.deltaX >= 0) {
          if (panPercentage >= 50) {
            console.log("Stack Pan End - Swipe Right Play");
            this.stackPlayInProgress = true;
            this.stackCardSwipeRightAI.play();
          } else {
            console.log("Stack Pan End - Swipe Right Reverse");
            this.stackPlayInProgress = true;
            this.stackCardSwipeRightAI.reverse();
          }
        } else {
          console.log("Stack Pan End - Swipe Right Reverse 2");
          this.stackPlayInProgress = true;
          this.stackCardSwipeRightAI.reverse();
          this.doResetStackScroll();
        }
      }
    }
    this.panStackCardIndex = -1;
  }

  calculateStackPanDistancePercentage($event) {
    let panDelta = $event.deltaX;
    let panPercentage =
      (Math.abs(panDelta) * 100) / this.STACK_CARD_MOVEMENT_WIDTH;
    return panPercentage;
  }

  getStackCaraouselPanProgress(deltaX) {
    let progress = Math.abs((deltaX / this.STACK_CARD_MOVEMENT_WIDTH) * 100);
    return progress;
  }

  panLeftStackHandler($event, index) {
    console.log(
      "Stack Pan Left",
      index,
      this.activeStackCardIndex,
      this.selectedStackCardIndex,
      $event.deltaX
    );
    if (this.stackPlayInProgress) {
      console.log(
        "Stack Pan Left Index Not Eligible For Swipe - Play In Progress"
      );
      return;
    }

    if (
      !(
        index == this.activeStackCardIndex ||
        index == this.activeStackCardIndex - 1
      )
    ) {
      console.log("Stack Pan Left Index Not Eligible For Pan");
      return;
    }

    if (this.panStackCardIndex != this.selectedStackCardIndex) {
      console.log(
        "Stack Pan Left Skipped - Mismatch Selected Cards",
        index,
        this.panStackCardIndex,
        this.selectedStackCardIndex
      );
      return;
    }

    if (index == this.swipedStackCardIndex) {
      console.log(
        "Stack Pan Left Skipped - Pan Left On Swipe Event",
        index,
        this.swipedStackCardIndex
      );
      return;
    }

    let panPercentage = this.calculateStackPanDistancePercentage($event);
    console.log("Stack Pan Left Progress", index, panPercentage);

    if (index == this.activeStackCardIndex - 1) {
      if ($event.deltaX <= 0) {
        if (panPercentage <= 100) {
          console.log("Stack Pan Left - Next Card as Active Seek Play");
          let progress = this.getStackCaraouselPanProgress($event.deltaX);
          this.seekStackCardSwipeLeftAnimation(progress);
        }
      }
    }

    if (
      index == this.activeStackCardIndex &&
      index < this.stackCards.length - 1
    ) {
      if ($event.deltaX >= 0) {
        if (panPercentage >= 0) {
          console.log("Stack Pan Left - Next Card as Active Seek Reverse");
          let progress = this.getStackCaraouselPanProgress($event.deltaX);
          this.seekStackCardSwipeRightAnimation(progress);
        }
      }
    }
  }

  panRightStackHandler($event, index) {
    console.log(
      "Stack Pan Right",
      index,
      this.activeStackCardIndex,
      this.selectedStackCardIndex,
      $event.deltaX
    );
    if (this.stackPlayInProgress) {
      console.log(
        "Stack Pan Right Index Not Eligible For Swipe - Play In Progress"
      );
      return;
    }

    if (
      !(
        index == this.activeStackCardIndex ||
        index == this.activeStackCardIndex - 1
      )
    ) {
      console.log("Stack Pan Rigjt Index Not Eligible For Pan");
      return;
    }

    if (this.panStackCardIndex != this.selectedStackCardIndex) {
      console.log(
        "Stack Pan Right Skipped - Mismatch Selected Cards",
        index,
        this.panStackCardIndex,
        this.selectedStackCardIndex
      );
      return;
    }

    if (index == this.swipedStackCardIndex) {
      console.log(
        "Stack Pan Right Skipped - Pan Right On Swipe Event",
        index,
        this.swipedStackCardIndex
      );
      return;
    }

    let panPercentage = this.calculateStackPanDistancePercentage($event);
    console.log("Stack Pan Right Progress", index, panPercentage);

    if (index == this.activeStackCardIndex - 1) {
      if ($event.deltaX <= 0) {
        if (panPercentage >= 0) {
          console.log("Stack Pan Right - Next Card as Active Seek Play");
          let progress = this.getStackCaraouselPanProgress($event.deltaX);
          this.seekStackCardSwipeLeftAnimation(progress);
        }
      }
    }

    if (
      index == this.activeStackCardIndex &&
      index < this.stackCards.length - 1
    ) {
      if ($event.deltaX >= 0) {
        if (panPercentage <= 100) {
          console.log("Stack Pan Right - Next Card as Active Seek Reverse");
          let progress = this.getStackCaraouselPanProgress($event.deltaX);
          this.seekStackCardSwipeRightAnimation(progress);
        }
      }
    }
  }

  seekStackCardSwipeLeftAnimation(progress) {
    let seekTime =
      this.STACK_CARD_SELECTION_ANIMATION_DURATION * (progress / 100);
    console.log("Seek", seekTime);
    let animeInstances = [];
    animeInstances.push(this.stackCardSwipeLeftAI);
    animeInstances.forEach((item) => {
      if (item) {
        //item.pause().seek(seekTime);
        item.pause().totalProgress(progress / 100.0);
      }
    });
  }

  seekStackCardSwipeRightAnimation(progress) {
    let seekTime =
      this.STACK_CARD_SELECTION_ANIMATION_DURATION * (progress / 100);
    console.log("Seek", seekTime);
    let animeInstances = [];
    animeInstances.push(this.stackCardSwipeRightAI);
    animeInstances.forEach((item) => {
      if (item) {
        //item.pause().seek(seekTime);
        item.pause().totalProgress(progress / 100.0);
      }
    });
  }

  panUpStackHandler($event, index) {
    console.log("Pan Up");
    this.panRightStackHandler($event, index);
  }

  panDownStackHandler($event, index) {
    console.log("Pan Down");
    this.panLeftStackHandler($event, index);
  }

  doResetStackScroll() {
    console.log("doResetStackScroll");
    this.selectedStackCardIndex = -1;
    this.stackPlayInProgress = false;
    this.resetStackScroll = true;
    this.changeDetectorRef.markForCheck();
    this.applicationRef.tick();
  }

  doNavigation() {
    this.ngZone.run(() => {
      this.router.navigate("/page-account-transactions".split("/"));
    });
  }

  isTransitionStackCard(index: number) {
    let isTouchActive =
      this.touchStackCardIndex != -1 &&
      this.touchStackCardIndex < this.stackCards.length - 1;
    let isTouchTransitionToCard =
      (index == this.activeStackCardIndex + 1 &&
        this.touchStackCardIndex == this.activeStackCardIndex) ||
      (index == this.activeStackCardIndex - 1 &&
        this.touchStackCardIndex == this.activeStackCardIndex - 1);
    let isSelectionActive =
      this.selectedStackCardIndex != -1 &&
      this.selectedStackCardIndex < this.stackCards.length - 1;
    let isSelectionTransitionToCard =
      (index == this.activeStackCardIndex + 1 &&
        this.selectedStackCardIndex == this.activeStackCardIndex) ||
      (index == this.activeStackCardIndex - 1 &&
        this.selectedStackCardIndex == this.activeStackCardIndex - 1);
    let isActiveCard = index == this.activeStackCardIndex;
    let result = isTouchActive
      ? isTouchTransitionToCard
      : isSelectionActive
        ? isSelectionTransitionToCard
        : isActiveCard;
    //console.log("isTransitionStackCard", index, result, isTouchActive, isTouchTransitionToCard, isSelectionActive, isSelectionTransitionToCard, isActiveCard);
    return result;
  }

  isActiveStackCardMinusTwoMinus(index: number) {
    return index < this.activeStackCardIndex - 2;
  }

  isActiveStackCardMinusOneMinus(index: number) {
    return index == this.activeStackCardIndex - 2;
  }

  isActiveStackCardMinusOne(index: number) {
    return index == this.activeStackCardIndex - 1;
  }

  isActiveStackCard(index: number) {
    return index == this.activeStackCardIndex;
  }

  isActiveStackCardPlusOne(index: number) {
    return index == this.activeStackCardIndex + 1;
  }

  isActiveStackCardPlusOnePlus(index: number) {
    return index == this.activeStackCardIndex + 2;
  }

  isActiveStackCardPlusTwoPlus(index: number) {
    return index > this.activeStackCardIndex + 2;
  }

  gotoApp(appName: string) {
    if (appName == "login") {
      this.services.isUserSignup = false;
      // this._router.navigate(['process-shell', 'kitchen', 'form-controls-check']);
      // return;

      /*SANTHOSH 12-DEC-2021 BEGIN*/
      if (this.services.mobile.isHybrid()) {
        ///FaceId or TouchId or mpin Check
        if (
          this._appCommon.isDeviceAuthRegistered ||
          this._appCommon.isMpinRegistered
        ) {
          // this.router.navigate(['login', 'mpin-login']);
          this._nativeStorage
            .retriveData("registeredUser")
            .then((value) => {
              console.log("registeredUservalue", value);
              const payload: ILoginauthPayLoad = {
                username: value,
                loginauth: "",
                remDevice: "",
                deviceId: "",
                password: "",
              };
              this._preLoginService.checkmpinregistered(payload).subscribe({
                next: (response: any) => {
                  let deviceRegistered = response.body.deviceRegistered;
                  let userRegistered = response.body.userRegistered;
                  if (
                    deviceRegistered == "false" &&
                    userRegistered == "false"
                  ) {
                    console.log("Create mpin false false");

                    this.ngZone.run(() => {
                      this._router.navigate(["login"]);
                    });
                  } else if (
                    deviceRegistered == "true" &&
                    userRegistered == "true"
                  ) {
                    console.log("VerifyMpin");
                    sessionStorage.setItem("OTHEROPTIONLOGIN", "true");

                    this.ngZone.run(() => {
                      this._router.navigate(["login", "mpin-login"]);
                    });
                  } else if (
                    deviceRegistered == "false" &&
                    userRegistered == "true"
                  ) {
                    console.log("Alert");
                    this._appCommon.isDeviceAuthRegistered = false;
                    this._appCommon.isMpinRegistered = false;
                    this.ngZone.run(() => {
                      this._router.navigate(["login"]);
                    });
                    // this._preLoginService.showAlert('mpin', 'MPIN', 'Proceeding further in the current device will de-register the existing device.', ['close', 'confirm'], 'confirmation');
                  } else if (
                    deviceRegistered == "true" &&
                    userRegistered == "false"
                  ) {
                    console.log("Create mpin true false");
                    this.ngZone.run(() => {
                      this._router.navigate(["login"]);
                    });
                  }
                },
              });
            })
            .catch((error) => {
              console.log("error", error);
              this.ngZone.run(() => {
                this.router.navigate(["login"]);
              });
            });
        } else {
          this.ngZone.run(() => {
            this.router.navigate(["login"]);
          });
        }
      } else {
        this.ngZone.run(() => {
          this.router.navigate(["login"]);
        });
      }
      /*SANTHOSH 12-DEC-2021 END*/
    }
  }

  doOpenNewAccount() {
    if (this.services.mobile.isPINConfigured) {
      sessionStorage.setItem("doOpenNewAccount", "1");
      this.gotoApp("login");
    } else {
      this.services.isUserSignup = true;

      this.ngZone.run(() => {
        this.services.router.navigate(["/onboarding/"]);
      });
    }
  }

  doOnboard() {
    if (this._appCommon.isDesktop()) {
      this._router.navigate(["onboarding", "process-shell", "rcob"], {
        queryParams: {
          processTitle: "NEW_TO_BANK.LBL_NEWTOBANK",
          processCode: "COB",
          formType: "1",
        },
        queryParamsHandling: "preserve",
      });
    } else {
      this._router.navigate(["process-shell", "rcob"], {
        queryParams: {
          processTitle: "NEW_TO_BANK.LBL_NEWTOBANK",
          processCode: "COB",
          formType: "1",
        },
        queryParamsHandling: "preserve",
      });
    }
  }

  private targetActiveCardIndex = -1;

  cardClick(index) {
    if (!this.playInProgress) {
      let menu = this.cards[index];

      if (this._appCommon.isDesktop()) {
        this.doRedirection(menu);
      } else {
        this.doRedirection(menu);
        return;
        if (this.activeCardIndex == index) {
          this.doRedirection(menu);
        }
        if (this.activeCardIndex != index) {
          if (index > this.activeCardIndex) {
            this.cardSelectorCarouselNextAsCurrentAIs[index].play();
            if (index == this.activeCardIndex + 1) {
              this.nextAsCurrentCardTimeline.play();
            } else {
              this.nextNextAsCurrentCardTimeline.play();
            }
          } else {
            this.cardSelectorCarouselPreviousAsCurrentAIs[index].play();
            this.previousAsCurrentCardTimeline.play();
          }
        }
      }
    }
  }

  doRedirection(menu: any) {
    let _data: IPopupScreenData;
    switch (menu.id) {
      case "login":
        this.gotoApp("login");
        break;
      case "selfRegister":
        this._preLoginService.setFlow("selfRegister");
        this.ngZone.run(() => {
          this.router.navigate(["selfRegister", "identity-yourself"]);
        });
        break;
      case "atmLocator":
        console.log("ATMbranch");

        this.ngZone.run(() => {
          this.router.navigate(["atmLocator", "google-map"]);
        });
        break;
      case "branchLocator":
        console.log("branch");

        this.ngZone.run(() => {
          this.router.navigate(["branchLocator", "googlemap-branch"]);
        });
        break;
      case "aboutus":
        _data = {
          component: "aboutUs",
          screenTitle: "WELCOMEMENU.aboutus",
        };
        // this.showMoreContent(_data);
        break;
      case "faq":
        _data = {
          component: "faq",
          screenTitle: "WELCOMEMENU.faq",
        };
        this.showMoreContent(_data);
        break;
      case "contactus":
        _data = {
          component: "contactus",
          screenTitle: "WELCOMEMENU.contactUs",
        };
        this.showMoreContent(_data);
        break;
      case "signup":
        console.log("signup");
        !this._appCommon.isMobile()
          ? this.router.navigate(["onboarding", "process-shell", "rcob"])
          : this.router.navigate(["process-shell", "rcob"]);
        break;

      case "securityTips":
        _data = {
          component: "securityTips",
          screenTitle: "WELCOMEMENU.securityTips",
        };
        this.showMoreContent(_data);
        break;
      default:
        if (menu.link) {
          window.open(menu.link, "_system");
        }
        break;
    }
  }

  showMoreContent(data: IPopupScreenData) {
    let dialogRef: MatDialogRef<any>;
    if (this._appCommon.isMobile()) {
      dialogRef = this._dialog.open(PopupComponent, {
        width: "100%",
        data: data,
        panelClass: "popup-screen",
      });
    } else {
      dialogRef = this._dialog.open(PopupComponent, {
        width: "455px",
        panelClass: "pre-login-popup",
        data: data,
        hasBackdrop: true,
      });
    }
    dialogRef.backdropClick().subscribe(() => {
      dialogRef.close();
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  stackCardClick(index) {
    if (this._responsive.isHybrid()) {
      this._preLoginService.checkForUpdate().subscribe({
        next: (res) => {
          console.log("checkForUpdate", res);
          if ((res.body.appversion.mandatory == "1" && res.body.appversion.updateAvailable == "1") || (res.body.appversion.mandatory == "0" && res.body.appversion.updateAvailable == "1")) {
            console.log("Result - Update pending");
          } else {
            if (!this.stackPlayInProgress && this.activeStackCardIndex == index) {
              switch (index) {
                case 0:
                  // this.doSelfRegister();
                  this.doOnboard();
                  break;
                case 1:
                  // this.doOpenNewAccount();
                  this.doOnboardCards();
                  break;
                default:
                  break;
              }
            }
          }
        },
      });
    }
  }

  doSelfRegister() {
    this.ngZone.run(() => {
      this.router.navigate(["selfRegister"]);
    });
  }

  doOnboardCards() {
    if (this._appCommon.isDesktop()) {
      this._router.navigate(
        ["onboarding", "process-shell", "rcob", "applicant-info"],
        {
          queryParams: {
            processTitle: "Apply new card",
            processCode: "CARDORG",
            formType: "1",
          },
          queryParamsHandling: "preserve",
        }
      );
    } else {
      this._router.navigate(["process-shell", "rcob", "applicant-info"], {
        queryParams: {
          processTitle: "Apply new card",
          processCode: "CARDORG",
          formType: "1",
        },
        queryParamsHandling: "preserve",
      });
    }
  }

  slides = [
    {
      h1: "New to CreditBank PNG?",
      p: "We would love to get you on board!",
      img: "./assets/images/app-start/product-new-customer.png",
    },
    {
      h1: "Save More",
      p: "Invest in Deposits for more returns.",
      img: "./assets/images/app-start/product-sber-friends.png",
    },
    {
      h1: "Banking everywhere",
      p: "A true mobile experience",
      img: "./assets/images/app-start/product-new-customer.png",
    },
    {
      h1: "Fund Payments",
      p: "Payment money to your friends and family via CreditBankApp",
      img: "./assets/images/app-start/product-sber-friends.png",
    },
    {
      h1: "Ensure Security",
      p: "Do not share Passwords, OTPs and PINs.",
      img: "./assets/images/app-start/product-new-customer.png",
    },
  ];
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: "linear",
  };
  // addSlide() {
  //   this.slides.push({ img: 'http://placehold.it/350x150/777777' });
  // }
  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }
  slickInit(e: any) {
    console.log("slick initialized");
  }
  breakpoint(e: any) {
    console.log("breakpoint");
  }
  afterChange(e: any) {
    console.log("afterChange");
  }
  beforeChange(e: any) {
    console.log("beforeChange");
  }
}
